import { APP_PLATFORM_VERSION } from '@semios/app-platform-version'
import type { TPersistentStoreName, TPersistentStoreOverrides } from '../persistenceStoresCleanUpMap'
import {
  PERSISTENCE_STORES_CLEANUP_MAP,
  STORES_TO_NOT_RESET_UNLESS_IN_CLEANUP_MAP,
} from '../persistenceStoresCleanUpMap'

export const checkIfStoreNeedsReset = (
  storeName: TPersistentStoreName,
  needsCleanupForThisVersionMap: TPersistentStoreOverrides,
): boolean => {
  const isAvoidCleanupCategory = STORES_TO_NOT_RESET_UNLESS_IN_CLEANUP_MAP.includes(storeName)

  if (isAvoidCleanupCategory) {
    const shouldResetForThisAppVersion = needsCleanupForThisVersionMap?.[storeName]

    if (shouldResetForThisAppVersion === true) {
      return true
    }
  } else {
    //this is always reset store category
    return true
  }

  return false
}

export const shouldStoreBeResetOnAppVersionChange = (storeName: TPersistentStoreName): boolean =>
  checkIfStoreNeedsReset(storeName, PERSISTENCE_STORES_CLEANUP_MAP[APP_PLATFORM_VERSION])
